import { InjectionToken, makeStateKey } from '@angular/core';
export const COUNTRY_VERSION_TOKEN = new InjectionToken<string>('countryVersionToken');
export const COUNTRY_VERSION_KEY = makeStateKey<string>('countryVersion');
